// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__30EAe","amount":"Amount_amount__38GtE","tip":"Amount_tip__3G8GE","tipHeader":"Amount_tipHeader__3jUl8","tipsWrap":"Amount_tipsWrap__2MD3E"};